import { render, staticRenderFns } from "./ykc-switch.vue?vue&type=template&id=6693da32"
import script from "./ykc-switch.vue?vue&type=script&lang=js"
export * from "./ykc-switch.vue?vue&type=script&lang=js"
import style0 from "./ykc-switch.vue?vue&type=style&index=0&id=6693da32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports